const DelegationState = {
    Pending: 1,
    Started: 2,
    Ended: 3,
    Failed: 4,
};
export default DelegationState;
